"use client";

import type { UseOpenApiQueryOptions } from "@packages/sdk";
import { useOpenApiQuery } from "@packages/sdk";

const urlBackendPath = "/me/pin/exists" as const;

export const keyMePinExists = () => ["me-pin-exists"];

export type UseRequestMePinExistsProps = Omit<
  UseOpenApiQueryOptions<typeof urlBackendPath>,
  "urlBackendPath"
>;

export const useRequestMePinExists = ({
  ...props
}: UseRequestMePinExistsProps = {}) =>
  useOpenApiQuery({
    ...props,
    queryKey: keyMePinExists(),
    urlBackendPath,
  });
